;(function () {
  angular
    .module('contrast.applications.modals')
    .controller(
      'AppUpgradeLicenseModalInstanceCtrl',
      AppUpgradeLicenseModalInstanceCtrl
    )

  function AppUpgradeLicenseModalInstanceCtrl($scope, $uibModalInstance) {
    'ngInject'

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
